module.exports = __webpack_public_path__ + "assets/img/nav_bg1.b89521ad.png";